import MaterialPopover, { PopoverProps } from '@mui/material/Popover';

export function Popover(props: PopoverProps) {
    return <MaterialPopover data-testid={'Popover-container'} {...props} />;
}
